import { defineMessages } from 'react-intl';

export default defineMessages({
    /**
     * Messages used in the *.metadata.json5
     */

    mandatoryValidationId: {
        id: 'fnol.pi.sasria-property-f4.mandatoryValidationId',
        defaultMessage: 'Mandatory field validation failed'
    },

    policyLimitMandatoryMessage: {
        id: 'fnol.pi.sasria-property-f4.policyLimitMandatoryMessage',
        defaultMessage: 'Missing required field "Policy Limit"'
    },

    passportNoValidationTitle: {
        id: 'fnol.common.policy-propertyF4.passportNoValidationTitle',
        defaultMessage: 'Passport Number validation has failed'
    },
    passportNoValidationMessage: {
        id: 'nol.common.policy-propertyF4.passportNoValidationMessage.',
        defaultMessage: 'Passport Number must be less than 13 digits and aplha numeric with no spaces.'
    },
    idNoValidationTitle: {
        id: 'fnol.common.policy-propertyF4.idNoValidationTitle',
        defaultMessage: 'Identity Number validation has failed'
    },
    idNoValidationMessage: {
        id: 'nol.common.policy-propertyF4.idNoValidationMessage.',
        defaultMessage: 'Identity Number must be 13 digit numeric number with no spaces(YYMMDDNNNNNNN).It is a mandatory field.'
    },

});
